class app {
  constructor() {}

  /**
   * @return void
   */
  overlay() {
    $("#overlay").fadeIn(500);
  }

  /**
   * @return void
   */
  overlayOut() {
    $("#overlay").fadeOut(500);
  }

  /**
   * @param string id
   * @return void
   */
  scroll(id){
    var target = document.getElementById(id);

    if (target) {
      $('html, body').animate({ scrollTop: target.offsetTop + 15 }, 500);
    }
  }
}

window.app = new app();


/**
 * Scroll Top Button
 */
jQuery(function() {
  var appear = false;
  var pagetop = $('#scroll-top');
  pagetop
    .stop()
    .animate({
      'right': '-50px'
    }, 300);

  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      if (appear == false) {
        appear = true;
        pagetop
          .stop()
          .tooltip('enable')
          .css('display', 'block')
          .animate({
            'right': '15px'
          }, 300);
      }
    } else {
      if (appear) {
        appear = false;
        pagetop
          .stop()
          .tooltip('disable')
          .tooltip('hide')
          .animate({
            'right': '-50px'
          }, 300)
          .tooltip('dispose');
      }
    }
  });

  pagetop.click(function () {
    $('body, html').animate({ scrollTop: 0 }, 500);
    return false;
  });
});

/**
 * Datetimepicker
 */
$(document).ready(function() {
  if ($("#datetimepicker").length != 0) {
    $('#datetimepicker').datetimepicker({
      icons: {
        time: "fa fa-clock-o",
        date: "fa fa-calendar",
        up: "fa fa-chevron-up",
        down: "fa fa-chevron-down",
        previous: 'fa fa-chevron-left',
        next: 'fa fa-chevron-right',
        today: 'fa fa-screenshot',
        clear: 'fa fa-trash',
        close: 'fa fa-remove'
      }
    });
  }
});
